export const handleEnterKeyDown = (itemId, setActiveCard) => (e) => {
  if (e.key === 'Enter') {
    setActiveCard(itemId);
  }
};

const getDeviceType = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  if (userAgent.includes("android")) {
    return "android";
  } else if (userAgent.includes("iphone") || userAgent.includes("ipad") || userAgent.includes("ipod")) {
    return "ios";
  } else {
    return "web";
  }
};

export const deviceType = getDeviceType();

